// 生产计划负责人值php订单处有做判断
const types0 = [{
    key:"0",
    value:"Sales Representative"
}];

export { types0 };